import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BuyerStateType, SetQueryPayloadType } from 'features/Account/@types/buyer'
import { SLICE_NAME, fetchBuyerList, updateBuyerStatus } from './buyerThunk'

const initialState: BuyerStateType = {
  isLoading: false,
  buyerList: [],
  cursorPaging: {
    next_cursor: '',
    prev_cursor: '',
  },
  query: { name: '', pageIndex: 0, pageSize: 20 },
  initialCursorNext: '',
}

const admin = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    resetCursorPaging: (state) => {
      state.cursorPaging = initialState.cursorPaging
    },
    setQuery: (state, action: PayloadAction<SetQueryPayloadType>) => {
      const { value, name } = action.payload

      state.query[name] = value as never
    },
    setInitialCursorNext: (state, action: PayloadAction<BuyerStateType['initialCursorNext']>) => {
      state.initialCursorNext = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchBuyerList.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchBuyerList.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(fetchBuyerList.fulfilled, (state, action) => {
        state.isLoading = false
        state.buyerList = action.payload.data.customers.map((el) => ({
          // ...el,
          uniqueKey: window.crypto.randomUUID(),
          customer_active: el.active,
          customer_astro_point: el.astro_point,
          customer_astro_point_fmt: el.astro_point_fmt,
          customer_email: el.email,
          customer_first_name: el.first_name,
          customer_id: el.id,
          customer_is_fraud: el.is_fraud,
          customer_is_fraud_referral: el.is_fraud_referral,
          customer_last_name: el.last_name,
          customer_phone_number: el.phone_number,
          customer_point: '',
          customer_referral_code: el.referral_code,
          customer_refund_point: el.refund_point,
          customer_refund_point_fmt: el.refund_point_fmt,
          customer_total_point: el.total_point,
          customer_total_point_fmt: el.total_point_fmt,
          is_new_buyer: el.is_new_buyer,
          is_twenty_one: el.is_twenty_one,
          total_device_count: el.total_device_count,
        }))
        state.cursorPaging = action.payload.data.pagination || initialState.cursorPaging
      })

      .addCase(updateBuyerStatus.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateBuyerStatus.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(updateBuyerStatus.fulfilled, (state) => {
        state.isLoading = false
      })
  },
})

export default admin.reducer
export const { reset, setQuery, resetCursorPaging, setInitialCursorNext } = admin.actions
